<div>
  <div class="mb-4">
    <p class="text-gray-600 mb-3">
      Add or edit your sources. You can enter text content or URLs to articles,
      documents, or other resources.
    </p>

    <app-sources-form
      [initialSources]="sources"
      [maxSourceItems]="maxSourceItems"
      [readonly]="readonly"
      (sourcesChange)="onSourcesChange($event)"
      (validityChange)="onFormValidityChange($event)"></app-sources-form>
  </div>

  <div class="flex justify-end gap-2 pt-3 border-t border-gray-200">
    <p-button
      label="Cancel"
      severity="secondary"
      variant="outlined"
      (click)="onCancel()" />

    @if (!readonly) {
      <p-button
        label="Save"
        severity="primary"
        [disabled]="!isFormValid"
        (click)="onSave()" />
    }
  </div>
</div>
